function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9223 17.6001C32.3828 17.6001 35.188 16.4541 35.188 15.0403C35.188 13.6266 32.3828 12.4806 28.9223 12.4806C25.4619 12.4806 22.6566 13.6266 22.6566 15.0403C22.6566 16.4541 25.4619 17.6001 28.9223 17.6001Z",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.188 19.1948C35.188 20.0582 34.1887 20.8201 32.5698 21.2264C31.3816 21.5564 30.154 21.7171 28.9223 21.7038C27.6939 21.7164 26.4698 21.5557 25.2848 21.2264C23.6959 20.7693 22.6666 20.0074 22.6666 19.1948",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.382 25.9498C30.446 25.924 31.503 25.7671 32.5298 25.4825C34.1187 25.0152 35.158 24.2534 35.158 23.4001",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.382 30.0738C30.4501 30.05 31.511 29.8896 32.5398 29.5964C34.1287 29.1393 35.158 28.3876 35.158 27.5648",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6566 22.2828V15.0302",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1881 15.0404V31.6788C35.1881 33.0298 32.6498 34.1268 29.412 34.2182",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.0777 29.2002C24.5382 29.2002 27.3434 28.0541 27.3434 26.6404C27.3434 25.2267 24.5382 24.0807 21.0777 24.0807C17.6173 24.0807 14.812 25.2267 14.812 26.6404C14.812 28.0541 17.6173 29.2002 21.0777 29.2002Z",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3834 30.8052C27.3834 31.6584 26.3841 32.4202 24.7652 32.8875C23.576 33.2127 22.3491 33.3732 21.1177 33.3649C19.8895 33.3739 18.6658 33.2133 17.4802 32.8875C15.8913 32.4202 14.852 31.6584 14.852 30.8052",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3834 26.6404V34.9596C27.3834 35.823 26.3841 36.5747 24.7552 37.0419C23.5704 37.3721 22.3461 37.5328 21.1177 37.5193C19.8892 37.5328 18.665 37.3721 17.4802 37.0419C15.8913 36.5747 14.852 35.823 14.852 34.9596V26.6404",
  stroke: "#45DB5D",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var SvgTotalNew = function SvgTotalNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTotalNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/total-new.ba914c15.svg";
export { ForwardRef as ReactComponent };